import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

const ProtectRoutes = () => {
  const users = useSelector((state) => state.user);
  // console.log(users?.currentUser, "auth");
  // return
  return users?.currentUser?.accessToken ? (
    <div className="main" id="main">
      <Outlet />
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectRoutes;